import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiX } from "react-icons/fi";
import { twMerge } from "tailwind-merge";

const Modal = ({
    isOpen,
    onClose,
    title,
    children,
    maxWidth = "max-w-2xl",
    showClose = true,
    fullScreen = false
}) => {
    // Prevent body scroll when modal is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [isOpen]);

    return (
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6">
                    {/* Backdrop with Blur */}
                    <motion.div
                        data-tour="modal-backdrop"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={onClose}
                        className="absolute inset-0 bg-black/40 backdrop-blur-[2px] "
                    />

                    {/* Modal Container */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.2, ease: "easeOut" }}
                        className={twMerge(
                            "relative bg-white shadow-2xl overflow-hidden flex flex-col w-full select-none ",
                            fullScreen ? "h-full rounded-md" : twMerge("max-h-[90vh] rounded-md", maxWidth)
                        )}
                        style={{ WebkitTapHighlightColor: 'transparent' }}
                    >
                        {/* Header */}
                        {(title || showClose) && (
                            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 shrink-0 bg-white/50 backdrop-blur-md sticky top-0 z-10">
                                <h3 data-tour="modal-header" className="text-xl font-bold text-[#1a1a1a] tracking-tight">
                                    {title}
                                </h3>
                                {showClose && (
                                    <button
                                        onClick={onClose}
                                        className="p-2 -mr-2 rounded-full hover:bg-gray-100 text-gray-400 hover:text-primary transition-all active:scale-95"
                                    >
                                        <FiX className="text-2xl" />
                                    </button>
                                )}
                            </div>
                        )}

                        {/* Content */}
                        <div className="flex-1 overflow-y-auto custom-scrollbar p-6">
                            {children}
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default Modal;
